/**
 * Puente React ↔ i18n. Vive aparte de `index.ts` para que el núcleo del i18n
 * (y su test) siga siendo puro: sin React y sin DOM.
 */
import { useSyncExternalStore } from 'react';
import { getLocale, subscribeLocale, translator, type TFunction } from './index';

/** Traductor del idioma activo; el componente se re-renderiza si cambia. */
export function useT(): TFunction {
  const locale = useSyncExternalStore(subscribeLocale, getLocale, getLocale);
  return translator(locale);
}
